import React from "react";
import EnergyChart from "../EnergyChart/";
import apiProxy from "../../api/apiProxy";

const loadSensorData = apiProxy.sensor.getDataFromDingo;

const DingoEnergyChart = props => {
  const resolution = {
    D: "RealTime",
    W: "FifteenMinutes",
    M: "Hourly",
    Y: "Daily"
  };

  const kWhDataResolution = {
    D: "ThirtyMinutes",
    W: "ThirtyMinutes",
    M: "Daily",
    Y: "Daily"
  };

  return (
    <EnergyChart
      {...props}
      sensorDataResolution={
        props.sensor.unit.description === "kWh" ? kWhDataResolution : resolution
      }
      loadSensorData={loadSensorData}
      convertToNonCumulative={
        props.sensor.unit.description === "kWh" ? true : false
      }
      useZeroMinYValue
    />
  );
};

export default DingoEnergyChart;
